import { useState, useEffect } from 'react'

/**
 * Retarde la mise à jour d'une valeur pour éviter trop d'appels API.
 * @param {*} value — valeur à débouncer
 * @param {number} delay — délai en ms (défaut 400ms)
 */
export function useDebounce(value, delay = 400) {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay)
    return () => clearTimeout(timer)
  }, [value, delay])

  return debounced
}
